<div [style]="'padding: 20px; background-color: white'">
  <aaa-form *ngIf="bs.componentState === bs.ComponentState.FORM"></aaa-form>
  <aaa-results *ngIf="bs.componentState === bs.ComponentState.RESULTS || environment.ngServe"></aaa-results>
  <aaa-no-results *ngIf="bs.componentState === bs.ComponentState.NO_RESULTS"></aaa-no-results>
</div>
